define("shared/components/shared/profile-avatar", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/helpers/profile-color-outline-class", "later/utils/object-promise-proxy", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _component2, _tracking, _emberConcurrency, _profileColorOutlineClass, _objectPromiseProxy, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/helpers/profile-color-outline-class",0,"later/utils/object-promise-proxy",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class={{concat-classes
      this.sizeClass
      this.outlineClass
      (if @isDisabled "u--mute")
      (concat "qa--creator_join_db_social_profiles_" @socialProfile.platformAbbreviation)
    }}
    data-profile-type={{@socialProfile.platformAbbreviation}}
    data-uid={{@socialProfile.uid}}
    ...attributes
    {{did-insert this.setInitialAvatarUrl}}
  >
    {{#if this.avatarUrl}}
      <span class="o--user__avatarProfile">
        <img
          alt={{@socialProfile.displayNickname}}
          class="o--user__avatar {{@avatarClass}}"
          data-test-avatar
          draggable="false"
          ondragstart="return false;"
          onerror={{perform this.handleError}}
          src={{this.avatarUrl}}
        />
      </span>
    {{else}}
      <span>
        <img
          alt={{@socialProfile.displayNickname}}
          class="o--user__avatar {{@avatarClass}}"
          data-test-avatar-placeholder
          draggable="false"
          ondragstart="return false;"
          src="/assets/images/img--userAvatar--placeholder.svg"
        />
      </span>
    {{/if}}
  
    {{#if @showPlatform}}
      <span class={{concat "o--user__avatarChild--" @socialProfile.cssHandle}} data-test-id="platform-icon">
        <i class={{concat "i--" @socialProfile.cssHandle "--w"}}></i>
      </span>
    {{/if}}
  
    {{#if @showDetails}}
      <span class="o--user__title" data-test-id="nickname">
        <span class="u--ellipsis {{@handleQaClass}}">
          {{@socialProfile.displayNickname}}
        </span>
      </span>
      <span class={{concat-classes "o--user__desc" @userDescriptionClass}} data-test-id="description">
        {{@socialProfile.accountType}}
        {{#if this.isAlpha}}
          <span class="u--text--uppercase">({{t "shared_words.beta"}})</span>
        {{/if}}
        {{#if @showProfileType}}
          |
          {{if @socialProfile.isLinkedinPersonalProfile (t "shared_words.profile") (t "linkedin.page")}}
        {{/if}}
      </span>
    {{/if}}
  
    {{yield}}
  </div>
  */
  {
    "id": "zm+gnvO5",
    "block": "[[[11,0],[16,0,[28,[37,0],[[30,0,[\"sizeClass\"]],[30,0,[\"outlineClass\"]],[52,[30,1],\"u--mute\"],[28,[37,2],[\"qa--creator_join_db_social_profiles_\",[30,2,[\"platformAbbreviation\"]]],null]],null]],[16,\"data-profile-type\",[30,2,[\"platformAbbreviation\"]]],[16,\"data-uid\",[30,2,[\"uid\"]]],[17,3],[4,[38,3],[[30,0,[\"setInitialAvatarUrl\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"avatarUrl\"]],[[[1,\"    \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[30,2,[\"displayNickname\"]]],[15,0,[29,[\"o--user__avatar \",[30,4]]]],[14,\"data-test-avatar\",\"\"],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,\"onerror\",[28,[37,4],[[30,0,[\"handleError\"]]],null]],[15,\"src\",[30,0,[\"avatarUrl\"]]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[12],[1,\"\\n      \"],[10,\"img\"],[15,\"alt\",[30,2,[\"displayNickname\"]]],[15,0,[29,[\"o--user__avatar \",[30,4]]]],[14,\"data-test-avatar-placeholder\",\"\"],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[14,\"src\",\"/assets/images/img--userAvatar--placeholder.svg\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[10,1],[15,0,[28,[37,2],[\"o--user__avatarChild--\",[30,2,[\"cssHandle\"]]],null]],[14,\"data-test-id\",\"platform-icon\"],[12],[1,\"\\n      \"],[10,\"i\"],[15,0,[28,[37,2],[\"i--\",[30,2,[\"cssHandle\"]],\"--w\"],null]],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,6],[[[1,\"    \"],[10,1],[14,0,\"o--user__title\"],[14,\"data-test-id\",\"nickname\"],[12],[1,\"\\n      \"],[10,1],[15,0,[29,[\"u--ellipsis \",[30,7]]]],[12],[1,\"\\n        \"],[1,[30,2,[\"displayNickname\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,1],[15,0,[28,[37,0],[\"o--user__desc\",[30,8]],null]],[14,\"data-test-id\",\"description\"],[12],[1,\"\\n      \"],[1,[30,2,[\"accountType\"]]],[1,\"\\n\"],[41,[30,0,[\"isAlpha\"]],[[[1,\"        \"],[10,1],[14,0,\"u--text--uppercase\"],[12],[1,\"(\"],[1,[28,[35,5],[\"shared_words.beta\"],null]],[1,\")\"],[13],[1,\"\\n\"]],[]],null],[41,[30,9],[[[1,\"        |\\n        \"],[1,[52,[30,2,[\"isLinkedinPersonalProfile\"]],[28,[37,5],[\"shared_words.profile\"],null],[28,[37,5],[\"linkedin.page\"],null]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[18,10,null],[1,\"\\n\"],[13]],[\"@isDisabled\",\"@socialProfile\",\"&attrs\",\"@avatarClass\",\"@showPlatform\",\"@showDetails\",\"@handleQaClass\",\"@userDescriptionClass\",\"@showProfileType\",\"&default\"],false,[\"concat-classes\",\"if\",\"concat\",\"did-insert\",\"perform\",\"t\",\"yield\"]]",
    "moduleName": "shared/components/shared/profile-avatar.hbs",
    "isStrictMode": false
  });
  /**
   * This component renders a Social Profile's avatar. This component will
   * automatically try to refresh the social profile if their avatar fails to load.
   * When the secureAvatarUrl changes, the component will try to display the new avatar,
   * and if that fails it will fallback to a default image, or in this case, a dash (-).
   *
   * Required Arguments:
   * - SocialProfile (SocialProfile|Object) A Social profile object that is used to display the correct image and info
   *
   * Optional Arguments:
   * - showPlatform (Boolean) Display an icon of the social profile's platform logo on platform color background.
   * - showDetails (Boolean) Display profile displayname and platform name as strings beside the avatar
   * - showOutline (Boolean) Display outline around avatar image in the color of the social platform
   * - avatarClass (String) A CSS Class to add to the avatar `div`
   * - size (String) The avatar size. Available options: "small", "medium", "large". Defaults to "medium"
   *
   * Examples:
   *
   * Simple Usage:
   * ```
   * <Shared::ProfileAvatar @socialProfile=this.socialProfile />
   * ```
   *
   * Inline Usage with all options:
   * ```
   * <Shared::ProfileAvatar
   *  @size="large"
   *  @avatarClass="u--m__0"
   *  @socialProfile=this.socialProfile
   *  @showPlatform={{true}}
   *  @showDetails={{true}}
   *  @showOutline={{true}}
   * />
   * ```
   *
   * Block Usage:
   * ```
   * <Shared::ProfileAvatar
   *  @size="large"
   *  @socialProfile=this.socialProfile
   * >
   *  <p class="u--text--md u--m__b__0 u--m__t__xs">
   *    custom text
   *  </p>
   * </Shared::ProfileAvatar>
   * ```
   */
  let ProfileAvatarComponent = _exports.default = (_class = class ProfileAvatarComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "isError", _descriptor, this);
      _initializerDefineProperty(this, "_initialAvatarUrl", _descriptor2, this);
      _defineProperty(this, "handleError", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this._initialAvatarUrl = this.socialProfile?.get('secureAvatarUrl');
          this.isError = true;
          const socialProfile = yield (0, _objectPromiseProxy.default)(this.socialProfile);
          if (socialProfile && socialProfile.refreshProfile && typeof socialProfile.refreshProfile === 'function') {
            socialProfile.get('refreshAndReload').perform();
          }
        }
      }), null, "handleError", null));
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
    get avatarUrl() {
      const url = this.socialProfile?.get('secureAvatarUrl');
      if (!this.isError) {
        return url;
      }
      return this._initialAvatarUrl !== url ? url : undefined;
    }
    get outlineClass() {
      if (!this.args.showOutline || !this.socialProfile?.get('profileColorClass')) {
        return '';
      }
      return (0, _profileColorOutlineClass.profileColorOutlineClass)([this.socialProfile.get('profileColorClass')]);
    }
    get sizeClass() {
      const sizeClasses = {
        small: 'o--user--sm',
        medium: 'o--user',
        large: 'o--user--lg',
        default: 'o--user'
      };
      if (this.args.size) {
        return sizeClasses[this.args.size] || sizeClasses.default;
      }
      return sizeClasses.default;
    }
    get isAlpha() {
      return this.socialProfile?.get('isSnapchat') || false;
    }
    setInitialAvatarUrl() {
      this._initialAvatarUrl = this.socialProfile?.get('secureAvatarUrl');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_initialAvatarUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setInitialAvatarUrl", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setInitialAvatarUrl"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileAvatarComponent);
});